import type { AuthProviderProps } from 'react-oidc-context'

// Keycloak-specific OIDC configuration.
// Environment variables are injected by Vite at build time.
//
// Required env vars (in .env.local or container env):
//   VITE_KEYCLOAK_URL    = https://auth.example.com
//   VITE_KEYCLOAK_REALM  = keel
//   VITE_KEYCLOAK_CLIENT = keel-console

const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8180'
const realm = import.meta.env.VITE_KEYCLOAK_REALM ?? 'keel'
const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT ?? 'keel-console'

// The authority is the Keycloak realm's OIDC issuer URL.
const authority = `${keycloakUrl}/realms/${realm}`

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  // PKCE flow (required for public clients)
  response_type: 'code',
  scope: 'openid profile email',
  // Silently renew the access token before expiry
  automaticSilentRenew: true,
  // Load userinfo endpoint to populate profile (name, email, etc.)
  loadUserInfo: true,
  // On sign-in callback, redirect back to the page the user was on
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname)
  },
}
